import { useNavigate } from '@tanstack/react-router';

import { PageHeader } from '@/shared/components/page-header';
import { Button } from '@/shared/components/shadcn/button';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';

export function SavedQueriesHeader() {
  const { workspaceId } = useWorkspaceId();
  const navigate = useNavigate();
  return (
    <PageHeader
      title="Listening"
      className="bg-white px-6"
      titleClassName="mb-0 text-3xl font-bold text-zinc-900"
      actions={
        <Button
          onClick={() =>
            navigate({ to: '/workspace/$workspaceId/create-new', params: { workspaceId } })
          }
        >
          Create new
        </Button>
      }
    />
  );
}
